import React, { FC } from "react";
import appConfig from "../../../../appConfig";
import CaseHeadClient from "../../../../components/caseHeadClient";
import openModal from "../../../../components/modal/openModal";
import TaxCaseStore from "../../../../contexts/taxCaseStore";
import { TaxCase } from "../../../../types/taxTypes";

const TaxCaseDealer: FC = () => {
  const { taxCase, setTaxCase } = TaxCaseStore.useContainer();
  const { client, id } = taxCase;
  const isWidgetCase = taxCase.caseSourceId ===  appConfig("widgetCaseSourceId");


  const handleClientChange = async () => {
    try {
      const newCase = await openModal<TaxCase>("changeClient", { id, client, context: "tax" });
      setTaxCase(newCase);
    } catch (ex) {
    }
  };

  return <CaseHeadClient onClientChange={handleClientChange} isWidgetCase={isWidgetCase} client={client} />;
};

export default TaxCaseDealer;
